"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.haemostaseologyTypeMessages = exports.hasDiseaseMessages = exports.HaemostaseologyType = exports.HasDisease = void 0;
const schema_1 = require("../../../../schema");
var HasDisease;
(function (HasDisease) {
    HasDisease["HAS_HAEMOSTASEOLOGY_DISEASE"] = "has_haemostaseology_disease";
    HasDisease["NO_UNKNOWN_HAEMOSTASEOLOGY_DISEASE"] = "no_unknown_haemostaseology_disease";
})(HasDisease || (exports.HasDisease = HasDisease = {}));
var HaemostaseologyType;
(function (HaemostaseologyType) {
    HaemostaseologyType["LOWER_LIMB_DEEP_VEIN_THROMBOSIS"] = "lower_limb_deep_vein_thrombosis";
    HaemostaseologyType["UPPER_LIMB_DEEP_VEIN_THROMBOSIS"] = "upper_limb_deep_vein_thrombosis";
    HaemostaseologyType["THROMBOSIS_NECK_REGION"] = "thrombosis_neck_region";
    HaemostaseologyType["PULMONARY_EMBOLISM"] = "pulmonary_embolism";
    HaemostaseologyType["SUPERFICIAL_VEIN_THROMBOSIS"] = "superficial_vein_thrombosis";
    HaemostaseologyType["CEREBRAL_SINUS_THROMBOSIS"] = "cerebral_sinus_thrombosis";
    HaemostaseologyType["HAEMOSTASEOLOGY_TYPE_OTHER"] = "haemostaseology_type_other";
})(HaemostaseologyType || (exports.HaemostaseologyType = HaemostaseologyType = {}));
exports.hasDiseaseMessages = {
    [HasDisease.HAS_HAEMOSTASEOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.hasDisease.HAS_HAEMOSTASEOLOGY_DISEASE",
        defaultMessage: "Diagnosztizált Thromboembolia"
    },
    [HasDisease.NO_UNKNOWN_HAEMOSTASEOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.hasDisease.NO_UNKNOWN_HAEMOSTASEOLOGY_DISEASE",
        defaultMessage: "Nincs vagy nem ismert"
    }
};
exports.haemostaseologyTypeMessages = {
    [HaemostaseologyType.LOWER_LIMB_DEEP_VEIN_THROMBOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.haemostaseologyType.LOWER_LIMB_DEEP_VEIN_THROMBOSIS",
        defaultMessage: "Alsó végtagi mélyvénás thrombosis"
    },
    [HaemostaseologyType.UPPER_LIMB_DEEP_VEIN_THROMBOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.haemostaseologyType.UPPER_LIMB_DEEP_VEIN_THROMBOSIS",
        defaultMessage: "Felső végtagi mélyvénás thromobosis"
    },
    [HaemostaseologyType.THROMBOSIS_NECK_REGION]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.haemostaseologyType.THROMBOSIS_NECK_REGION",
        defaultMessage: "Thrombosis nyaki régióban"
    },
    [HaemostaseologyType.PULMONARY_EMBOLISM]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.haemostaseologyType.PULMONARY_EMBOLISM",
        defaultMessage: "Pulmonális embolia"
    },
    [HaemostaseologyType.SUPERFICIAL_VEIN_THROMBOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.haemostaseologyType.SUPERFICIAL_VEIN_THROMBOSIS",
        defaultMessage: "Felületes véna thrombosis"
    },
    [HaemostaseologyType.CEREBRAL_SINUS_THROMBOSIS]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.haemostaseologyType.CEREBRAL_SINUS_THROMBOSIS",
        defaultMessage: "Agyi sinus thrombosis"
    },
    [HaemostaseologyType.HAEMOSTASEOLOGY_TYPE_OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.haemostaseology.haemostaseologyType.HAEMOSTASEOLOGY_TYPE_OTHER",
        defaultMessage: "Egyéb thromboembolia"
    }
};
const hasDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasDisease.HAS_HAEMOSTASEOLOGY_DISEASE).interpretation({ vocab: "ktx", code: "has_haemostaseology_disease" }),
    schema_1.Schema.singleChoiceItem(HasDisease.NO_UNKNOWN_HAEMOSTASEOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "no_unknown_haemostaseology_disease"
    })
        .tag({ vocab: "ktx", code: "haemostaseology_type" })
]).interpretation({ vocab: "ktx", code: "has_haemostaseology_disease_choice" });
const haemostaseologyType = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(HaemostaseologyType.LOWER_LIMB_DEEP_VEIN_THROMBOSIS)
        .interpretation({
        vocab: "ktx",
        code: "lower_limb_deep_vein_thrombosis"
    })
        .tag({ vocab: "ktx", code: "haemostaseology_type" }),
    schema_1.Schema.multiChoiceItem(HaemostaseologyType.UPPER_LIMB_DEEP_VEIN_THROMBOSIS)
        .interpretation({
        vocab: "ktx",
        code: "upper_limb_deep_vein_thrombosis"
    })
        .tag({ vocab: "ktx", code: "haemostaseology_type" }),
    schema_1.Schema.multiChoiceItem(HaemostaseologyType.THROMBOSIS_NECK_REGION)
        .interpretation({ vocab: "ktx", code: "thrombosis_neck_region" })
        .tag({ vocab: "ktx", code: "haemostaseology_type" }),
    schema_1.Schema.multiChoiceItem(HaemostaseologyType.PULMONARY_EMBOLISM)
        .interpretation({ vocab: "ktx", code: "pulmonary_embolism" })
        .tag({ vocab: "ktx", code: "haemostaseology_type" }),
    schema_1.Schema.multiChoiceItem(HaemostaseologyType.SUPERFICIAL_VEIN_THROMBOSIS)
        .interpretation({ vocab: "ktx", code: "superficial_vein_thrombosis" })
        .tag({ vocab: "ktx", code: "haemostaseology_type" }),
    schema_1.Schema.multiChoiceItem(HaemostaseologyType.CEREBRAL_SINUS_THROMBOSIS)
        .interpretation({ vocab: "ktx", code: "cerebral_sinus_thrombosis" })
        .tag({ vocab: "ktx", code: "haemostaseology_type" }),
    schema_1.Schema.multiChoiceItem(HaemostaseologyType.HAEMOSTASEOLOGY_TYPE_OTHER)
]);
const haemostaseologyTypeOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../haemostaseologyType}) && ({../haemostaseologyType}).includes("haemostaseology_type_other")`), schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({ vocab: "ktx", code: "haemostaseology_type_other" })
    .tag({ vocab: "ktx", code: "haemostaseology_type" }));
const diseases = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasDisease} === "has_haemostaseology_disease"`), schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ haemostaseologyType, haemostaseologyTypeOther }));
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasDisease, diseases, comment })
    .interpretation({ vocab: "ktx", code: "haemostaseology" });
